/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgClipboardDown = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M16 2v2h4v6h-2V6h-2v2H6V6H4v14h9v2H2V4l4-.001V2zm4.03 10-.001 6.227 1.298-1.254 1.435 1.388L19 22l-3.762-3.639 1.435-1.388L18 18.257V12zM14 4H8.03l-.001 1.999H14z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgClipboardDown as ClipboardDown };
